var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTipsAndUpdates(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28511_511)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.20833 17.4999H8.54167C8.54167 18.4166 7.79167 19.1666 6.875 19.1666C5.95833 19.1666 5.20833 18.4166 5.20833 17.4999ZM3.54167 16.6666H10.2083V14.9999H3.54167V16.6666ZM13.125 8.74992C13.125 11.9333 10.9083 13.6333 9.98333 14.1666H3.76667C2.84167 13.6333 0.625 11.9333 0.625 8.74992C0.625 5.29992 3.425 2.49992 6.875 2.49992C10.325 2.49992 13.125 5.29992 13.125 8.74992ZM11.4583 8.74992C11.4583 6.22492 9.4 4.16658 6.875 4.16658C4.35 4.16658 2.29167 6.22492 2.29167 8.74992C2.29167 10.8083 3.53333 11.9916 4.25 12.4999H9.5C10.2167 11.9916 11.4583 10.8083 11.4583 8.74992ZM17.1833 6.97492L16.0417 7.49992L17.1833 8.02492L17.7083 9.16658L18.2333 8.02492L19.375 7.49992L18.2333 6.97492L17.7083 5.83325L17.1833 6.97492ZM15.2083 5.83325L15.9917 4.11659L17.7083 3.33325L15.9917 2.54992L15.2083 0.833252L14.425 2.54992L12.7083 3.33325L14.425 4.11659L15.2083 5.83325Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28511_511"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipsAndUpdates);
export default __webpack_public_path__ + "static/media/tips_and_updates.76b77c918760c6d06e8a377be3679291.svg";
export { ForwardRef as ReactComponent };